import './search.scss';
import ScrollLock from '../../components/scroll-lock/scroll-lock';

class Search {
    constructor (element) {
        this.$search = element;
        this.$searchInput = this.$search.querySelector('[data-search="input"]');
        this.$searchButton = this.$search.querySelector('[data-search="button"]');
        this.$closeButton = this.$search.querySelector('[data-search="close"]');
        this.$searchResults = this.$search.querySelector('[data-search="results"]');
        this.$form = this.$search.querySelector('[data-search="form"]');

        this.searchOpen = false;
    }

    initialize () {
        if (this.$search) {
            this.setEvents();
        }
    }

    setEvents () {
        if (this.$closeButton) {
            this.$closeButton.addEventListener('click', () => {
                this.closeSearch();
                this.$searchInput.value = '';
            });
        }

        if (this.$searchInput) {
            this.setFetch();
        }

        if (this.$form) {
            this.$form.onsubmit = (e) => {
                e.preventDefault();
            };
        }

        document.body.addEventListener('click', (e) => {
            if (this.searchOpen) {
                const $clickedElement = e.target;
                let dataOverlay = $clickedElement.getAttribute('data-search');
                if (!dataOverlay) {
                    const $parentElement = $clickedElement.closest('[data-search]');
                    if ($parentElement) {
                        dataOverlay = true;
                    }
                }

                if (!dataOverlay) {
                    this.closeSearch();
                }
            }
        });
    }

    setFetch () {
        let debounceTimer;
        const $searchResult = this.$searchResults;

        this.$searchInput.addEventListener('input', (e) => {
            const value = this.$searchInput.value.trim();

            if (e.keyCode === 13) {
                return;
            }

            if (value.length <= 2) {
                this.closeSearch();
                return;
            } else {
                this.openSearch();
            }

            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(() => {
                doFetch(this.$form.action, value);
            }, 300);
        });

        async function doFetch (url, searchTerm) {
            try {
                const fetchUrl = new URL(url);
                fetchUrl.searchParams.append('term', searchTerm);

                const response = await fetch(fetchUrl);

                if (!response.ok) throw new Error('Fehler beim Laden');
                const newHTML = await response.text();
                $searchResult.innerHTML = newHTML;
            } catch (error) {
                console.error(error);
            }
        }
    }

    openSearch () {
        window.scrollTo(0, 0);
        this.$searchButton.setAttribute('aria-hidden', 'true');
        this.$closeButton.setAttribute('aria-hidden', 'false');
        ScrollLock.disableScroll();
        this.$searchResults.classList.add('is--visible');
        this.$searchInput.focus();
        this.searchOpen = true;
    }

    closeSearch () {
        this.$searchButton.setAttribute('aria-hidden', 'false');
        this.$closeButton.setAttribute('aria-hidden', 'true');
        this.$searchResults.classList.remove('is--visible');
        ScrollLock.enableScroll();
        this.$searchInput.focus();
        this.searchOpen = false;
    }
}

export { Search };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $search = $context.querySelector('[data-search="root"]');

        if ($search) {
            const searchAPI = new Search($search);
            searchAPI.initialize();
        }
    }
});
